module.exports = __webpack_public_path__ + "img/lusterinc-logo.43fc4842.png";